/**
 * NotificationRenderer — renders all active notifications from the store.
 * Mount once in App.tsx (replaces ToastProvider rendering).
 * Handles toast stacking, banner, and dialog rendering.
 */

import { useNotificationStore, selectVisibleNotifications, selectQueuedCount } from '../../store/notificationStore';
import { NotificationToast } from './NotificationToast';
import { SystemBanner } from './SystemBanner';
import { ErrorDialog } from './ErrorDialog';
import './NotificationRenderer.css';

export const NotificationRenderer = () => {
  const visibleNotifications = useNotificationStore(selectVisibleNotifications);
  const queuedCount = useNotificationStore(selectQueuedCount);
  const banner = useNotificationStore((s) => s.banner);
  const dialog = useNotificationStore((s) => s.dialog);

  return (
    <>
      {/* System banner — top of viewport */}
      {banner && <SystemBanner />}

      {/* Toast stack — top-right */}
      {visibleNotifications.length > 0 && (
        <div
          className="notification-stack"
          aria-label="Notifications"
          role="region"
        >
          {visibleNotifications.map((notification, index) => (
            <div
              key={notification.id}
              className="notification-stack__item"
              style={{ '--stagger-i': index } as React.CSSProperties}
            >
              <NotificationToast notification={notification} />
            </div>
          ))}
          {queuedCount > 0 && (
            <div className="notification-stack__queued">
              +{queuedCount} more
            </div>
          )}
        </div>
      )}

      {/* Error dialog — modal overlay */}
      {dialog && <ErrorDialog />}
    </>
  );
};
